import React from "react";
import {
  Typography,
  Container,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Grow,
} from "@mui/material";
import { Code, Web, Phone } from "@mui/icons-material";
import "../../styles/components/ServicesSection.css";

function ServicesSection() {
  const services = [
    {
      icon: <Code sx={{ fontSize: 80, color: "white" }} />,
      title: "Full Stack Development",
      description:
        "Building robust web applications from frontend to backend, ensuring seamless user experiences and scalable architecture.",
      color: "#0066CC",
      delay: 1000,
    },
    {
      icon: <Web sx={{ fontSize: 80, color: "white" }} />,
      title: "Responsive Design",
      description:
        "Creating beautiful, mobile-first designs that work perfectly across all devices and screen sizes.",
      color: "#008CFF",
      delay: 1200,
    },
    {
      icon: <Phone sx={{ fontSize: 80, color: "white" }} />,
      title: "Problem Solving",
      description:
        "Tackling complex technical challenges with innovative solutions and a systematic approach to development.",
      color: "#A0A0A0",
      delay: 1400,
    },
  ];

  return (
    <Container sx={{ py: { xs: 5, md: 8 } }}>
      <Typography
        variant="h3"
        component="h2"
        textAlign="center"
        gutterBottom
        sx={{ mb: { xs: 3, md: 6 }, fontWeight: 600 }}
      >
        Services
      </Typography>

      <Grid
        container
        rowSpacing={{ xs: 2, md: 4 }}
        columnSpacing={{ xs: 0, md: 4 }}
      >
        {services.map((service, index) => (
          <Grid item xs={12} md={4} key={service.title}>
            <Grow in timeout={service.delay}>
              <Card className="feature-card">
                <CardMedia
                  component="div"
                  sx={{
                    height: { xs: 160, sm: 180, md: 200 },
                    backgroundColor: service.color,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {service.icon}
                </CardMedia>
                <CardContent>
                  <Typography variant="h5" component="h3" gutterBottom>
                    {service.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {service.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grow>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}

export default ServicesSection;
